var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.loading.status,"z-index":"9999"}},[(_vm.loading.circular)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }